<template>
  <div class="appTable">
    <div class="appTable__info">
      <AppPageHeader></AppPageHeader>
    </div>
    <div class="appTable__tool">
      <div class="appTable__tool__left">
        <!-- slot : tools -->
        <slot name="tools"></slot>
      </div>
      <div class="appTable__tool__right">
        <el-button
          type="primary"
          :icon="isFilter? 'el-icon-receiving' : 'el-icon-files'"
          :title="isFilter? '收起筛选选项' : '更多筛选选项'"
          @click="doFilter"
        ></el-button>

        <el-input v-model="searchword" :placeholder="searchPlaceHolder" @change="onSWchanged">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>
    <el-collapse-transition>
      <div class="appTable_tool_filter" v-show="isFilter">
        <template v-if="FilterStatusDefault">
          <selectTableFilterStatus
            ref="selectTableFilterStatus"
            :showReviewOption="showReviewOption"
            @onDataChanged="onTableFilterStatusDataChanged"
          ></selectTableFilterStatus>
        </template>
        <slot name="filter"></slot>
      </div>
    </el-collapse-transition>
    <div class="appTable__tool__fixed">
      <slot name="fixedFilter"></slot>
    </div>

    <!-- 默认的Table控件 -->
    <el-table
      :data="datas"
      stripe
      border
      class="appTable__datas"
      header-row-class-name="table-header-row"
      v-loading="loadingTable"
    >
      <template v-if="expand">
        <el-table-column type="expand">
          <template slot-scope="props">
            <slot name="expand" :props="props"></slot>
          </template>
        </el-table-column>
      </template>

      <el-table-column
          type="index"
          width="50">
      </el-table-column>

      <template v-for="item in columns">
        <template v-if="item.scope">
          <el-table-column :label="item.label" :key="item.prop" :width="item.width">
            <template slot-scope="scope">
              <slot name="columnSlotFirst" :props="scope"></slot>
            </template>
          </el-table-column>
        </template>
        <template v-if="!item.scope">
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :width="item.width"
          ></el-table-column>
        </template>

        <template v-if="item.isStatus">
          <template slot-scope="scope">
            <p
              :class="getTableStatusClass(scope.row.status)"
              :key="item.prop"
            >{{scope.row.statusStr}}</p>
          </template>
        </template>
      </template>

      <el-table-column
        label="当前状态"
        width="100px"
        v-if="!fromschedulingreview&&!fromschedulingreport"
      >
        <template slot-scope="scope">
          <StatusTag :status="scope.row.status"></StatusTag>
          <!-- <el-tag
          :type="getTableStatusClass(scope.row.status)">{{scope.row.statusStr}}</el-tag>-->
          <!-- <p :class="getTableStatusClass(scope.row.status)">{{scope.row.statusStr}}</p> -->
        </template>
      </el-table-column>
      <el-table-column label="审核状态" width="100px" v-else>
        <template slot-scope="scope">
          <div>
            <p v-if="scope.row.status == 0">未审核</p>
            <p v-if="scope.row.status == 1">审核通过</p>
            <p v-if="scope.row.status == 2">审核失败</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        class-name="column__tool"
        v-if="!fromschedulingreview&&!fromschedulingreport"
      >
        <template slot-scope="scope">
          <template v-if="tableToolConfig.canRecover">
            <StartTableBtn
              v-if="scope.row.status==1"
              :serverUrl="serverUrl"
              :id="scope.row.id"
              :title="scope.row.title"
              @onSuccess="onToolSuccess"
            ></StartTableBtn>
          </template>
          <template v-if="tableToolConfig.canEdit">
            <router-link :to="{path:baseUrl + '/edit',query:{id:scope.row.id}}">
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.status !=2"
                plain
                icon="el-icon-edit"
                class="column__tool__buttom"
              >修改&nbsp;</el-button>
            </router-link>
          </template>
          <template v-if="tableToolConfig.canDelete">
            <DeleteTableBtn
              v-if="scope.row.status==1"
              :serverUrl="serverUrl"
              :id="scope.row.id"
              :title="scope.row.title || scope.row.name"
              @onSuccess="onToolSuccess"
            ></DeleteTableBtn>
          </template>
          <template v-if="tableToolConfig.canDisable">
            <DisableTableBtn
              v-if="scope.row.status==0"
              :serverUrl="serverUrl"
              :id="scope.row.id"
              :title="scope.row.title || scope.row.name"
              @onSuccess="onToolSuccess"
            ></DisableTableBtn>
          </template>

          <slot name="columnSlotTool" :props="scope.row.id"></slot>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        class-name="column__tool"
        v-if="fromschedulingreview"
      >
        <template slot-scope="scope">
          <template>
            <template>
              <router-link :to="{path:'/standard/review/detail',query:{id:scope.row.id}}">
                <el-button>处理</el-button>
              </router-link>
            </template>
          </template>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" class-name="column__tool" v-if="fromschedulingreport">
        <template slot-scope="scope">
          <template>
            <template>
              <router-link :to="{path:'/standard/review/detail',query:{id:scope.row.id}}">
                <el-button type="primary">查看详情</el-button>
              </router-link>
            </template>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div class="appTable__footer">
      <div class="appTable__footer_page">
        <el-pagination
          :key="elementui_page_component_key"
          :pager-count="5"
          class="el-pag"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="sizes,total,next, pager,prev,jumper "
          :total="total"
        ></el-pagination>
      </div>
      <div class="appTable__footer__info">
        <p>
          <i class="el-icon-info"></i>
          <slot name="table__footer__info"></slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { selectTableFilterStatus } from "../select";
import {
  StatusTag,
  DisableTableBtn,
  StartTableBtn,
  DeleteTableBtn,
} from "./comp";
import { getListApi } from "@/api/core/table/table";
import { getPageData,cachePage,cacheSize,cachePageData} from "@/utils/tablestorage";

export default {
  name: "table-container-ref",
  props:{
    serverUrl:{
      type: String
    },
    columns:{
      type: Array
    },
    tableToolConfig:{
      type: Object
    },
    FilterStatusDefault: {
      type: Boolean,
      default: true
    },
    expand: {
      type: Boolean,
      default: false
    },
    baseUrl: {
      type: String,
      default: false
    },
    showReviewOption: {
      type: Boolean,
      default: false
    },
    searchPlaceHolder:{
      type: String,
      default: '快速搜索内容"'
    },
    fromschedulingreview: {
      type: Boolean
    },
    fromschedulingreport: {
      type: Boolean
    },
  },
  components: {
    StatusTag,DisableTableBtn,StartTableBtn,DeleteTableBtn,selectTableFilterStatus
  },
  data() {
    return {
      isFilter : true, // 是否展开更多筛选项
      isRefreshing : false,
      loadingTable : false, // 正在加载表单

      datas : [], // table 数据
      // filter params
      searchword : "", // 搜索关键字
      status : 0,
      // 外部传入的筛选只
      sid : "",
      pid : "",
      rsid:"",
      partyid : "",
      unitid : "",
      ccpid : -1,
      checkid : -1,
      // 分页
      currentPage : 1,
      pageSize : 10,
      total : 0,

      elementui_page_component_key : 0,

      dataMap: new Map(), // 数据 map
    }
  },
  methods:{
    initTable() {

      let pageData = getPageData(this.$route.name);

      this.currentPage = pageData.page;
      this.pageSize = pageData.size;


      // 包裹参数
      let serverUrl = this.serverUrl;
      let tableFilterData = {
        pid: this.pid,
        sid: this.sid,
        rsid: this.rsid,
        unitid: this.unitid,
        partyid: this.partyid,
        ccpid: this.ccpid,
        checkid: this.checkid,
        status: this.status,
        searchword: this.searchword,
        dataMap: this.dataMap
      };


      let start = (this.currentPage - 1) * this.pageSize;

      let tablePageData = {
        page:this.currentPage,
        current:this.currentPage,
        start: start,
        size: this.pageSize,
      };

      this.loadingTable = true;

      getListApi(serverUrl, tableFilterData, tablePageData)
        .then((response) => {
          let total = response.total;
          if(response.datas){
            this.datas = response.datas
          }
          if(response.records){
            this.datas = response.records
          }
          this.total = total;
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },
    DoInit() {
      // 恢复默认
      this.pageSize = 10;
      this.currentPage = 1;
      this.searchword = "";
      this.status = 0;
      this.initTable();
    },

    onSWchanged(val){
      console.log("sw",this.searchword)
      this.initTable();
    },


    doFilter() {
      this.isFilter = !this.isFilter;
    },

    onToolSuccess() {
      this.initTable();
    },

    // 状态选择框/所属学习班改动
    onTableFilterStatusDataChanged(value) {
      // localStorage.setItem(this.$route.name + "status",);

      this.status = value;
      this.initTable();
    },

    
    // 外部筛选框输入
    updateParams(pkey, pval) {
      if (!this.dataMap) {
        this.dataMap = new Map();
      }
      this.currentPage = 1;

      this.dataMap.set(pkey, pval);
      localStorage.setItem(this.$route.name + "dataMap",this.dataMap);
      this.initTable();
    },

    // 外部筛选框输入
    updateSid(sid) {
      this.sid = sid;
      this.currentPage = 1;
      this.initTable();
    },

    updatePid(pid) {
      this.pid = pid;
      this.initTable();
    },
    updatePartyid(partyid) {
      this.partyid = partyid;
      this.initTable();
    },
    updateUnitid(unitid) {
      this.unitid = unitid;
      this.initTable();
    },
    updateCcpid(ccpid) {
      this.ccpid = ccpid;
      this.initTable();
    },
    updateCheckid(checkid) {
      this.checkid = checkid;
      this.initTable();
    },
    updateRSid(sid) {
      this.rsid = sid;
      this.initTable();
    },

    // 分页
    handleSizeChange(p) {
      this.pageSize = p;
      this.currentPage = 1;


      cachePageData(this.$route.name,this.currentPage,this.pageSize)


      this.initTable();
    },

    handleCurrentChange(p) {

      cachePageData(this.$route.name,this.currentPage,this.pageSize)

      this.currentPage = p;
      this.initTable();
    },
  },
  // 生命周期钩子
  mounted() {
    this.initTable();

    this.elementui_page_component_key ++;
  }
}

</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
